/**
 * Classe com funções para o modal nas telas de RouteMonitor
 *
 * @author: Adalto Junior
 * DATE: 17/04/2013
 *
 */


Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.ModalUtils = function () {

    /**
     * Faz algumas modificações no ambiente onde o modal será inserido, nesse caso, modifica
     * o CSS do overlay para que ele se ajuste ao esquema de posicionamento dessa aba.
     */

    this.ajustModalOverlay = function (selector) {

        var modalOverlay = document.querySelector(`${selector} .blockOverlay`);
        var error = null;

        if (modalOverlay !== null) {

            try {

                modalOverlay.style.cssText = "z-index: 1000; border: none; margin: 0px; padding: 0px; top: 75px; background-color: rgb(0, 0, 0); opacity: 0.6; position: fixed; bottom: 18px; left: 0px; right: 0px;";

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    "Your browser dont't have cssText support for this dom element.");
                error.console();

            }

        } else {

            error = new Monet.Exception.ReturnError(this,
                "Theres no div with class .blockOverlay to change style.");
            error.console();

        }

    };

    this.showErrorMessage = function (messageScope, name, message) {

        var monetMessage = new Monet.Form.Messages.InlineMessage();

        var errorMessages = {
                errorMessages: [
                  Monet.Form.Messages.mountErrorMessageObject(message)
                ]
            };

        monetMessage.setScope(messageScope);
        monetMessage.setInfoType("error");
        monetMessage.setMessage(errorMessages);
        monetMessage.triggerMessage();

    };


    this.removeAllActionListener = (lookupField, items, type, shouldHide, successCallback) => {
        const containerLookupList = document.querySelector('.container_lookuplist_added');
        const oldRemoveAllBtn = document.querySelector('.power-lookup-list-remove-all-elements');
        const removeAllBtn = document.createElement('div');

        if(containerLookupList && oldRemoveAllBtn) {
            oldRemoveAllBtn.parentNode.removeChild(oldRemoveAllBtn);
            removeAllBtn.classList.add('power-lookup-list-remove-all-elements');
            removeAllBtn.innerHTML = `<i class="fa fa-trash-o"></i> ${Monet.I18n.getResourcesByKey('lookupList.removeAllElements')}`;

            if(!shouldHide) {
                containerLookupList.appendChild(removeAllBtn);
            }

            const removeAll = () => {
                let lookUpValues = lookupField.getValue();

                lookUpValues = lookUpValues.map(e => e.id);

                const itemsToRemove = items.filter(e =>  lookUpValues.includes(e[type].id)).map(e => e.id);

                const success = () => {
                    lookupField.clear();
                    removeAllBtn.addEventListener("click", removeAll);
                    items = [];
                    successCallback?.();
                }

                const error = () => {
                    removeAllBtn.addEventListener("click", removeAll);
                }

                if(itemsToRemove.length) {
                    const model = getModel()
                    removeAllBtn.removeEventListener("click", removeAll);
                    model.unassignAllToRoute({ assignmentsListId: itemsToRemove }, success, error);

                } else {
                    lookupField.clear();
                }
            }

            const getModel = () => {
                const model = {
                    'driver': new App.Models.RouteDriverAssignment(),
                    'equipment': new App.Models.RouteEquipmentAssignment(),
                    'helper': new App.Models.RouteHelperAssignment(),
                    'tag': new App.Models.RouteTagAssignment()
                }
                return model[type]
            }

            removeAllBtn.addEventListener('click', removeAll);
        }
    }

};
